var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({staticClass:"video-card-skeleton"},'div',_vm.$attrs,false),[_c('transition',{attrs:{"name":"fade"}},[_c('span',{staticClass:"video-card-skeleton__thumb"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }